<template>
  <div class="container">
    <div class="col-xs-12">
      <h2 class="sc-navy text-align-center">Unlock Swisscom's Messaging Experience</h2>
    </div>
    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-12 col-md central-separator central-separator__height">
        </div>
        <div class="col-xs-12 col-md">
        </div>
      </div>
      <div class="row padding-top-4">
        <div class="col-xs-12 col-md text-align-right">
          <sdx-button
              class="col-xs-6 margin-bottom-2"
              data-testid="oidbLoginButton"
              type="button"
              label="Swisscom Login"
              @click="oidbLogin()"></sdx-button>
          <br v-if="showWiremockLogin()"/>
          <sdx-button
              v-if="showWiremockLogin()"
              class="col-xs-6 margin-bottom-2"
              data-testid="wiremockLoginButton"
              type="button"
              label="WireMock Login"
              @click="wiremockLogin()"></sdx-button>
          <br>
          <span class="col-md">
            You don't have a Swisscom Login yet?
            <br/>
            <a href="https://digital.swisscom.com/login-help-center">Learn how to register!</a>
          </span>
        </div>
        <div class="col-xs-2 col-md-1 text-align-center margin-top-1 central-separator__text">
          OR
        </div>
        <div class="col-xs-12 col-md">
          <sdx-button
              class="col-xs-6"
              type="button"
              label="Swisscom Employee Login"
              icon-name="icon-key"
              @click="employeeLogin()"></sdx-button>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md central-separator central-separator__height">
        </div>
        <div class="col-xs-12 col-md">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import envService from "@/services/env.service";

export default {
  computed: {
    envService() {
      return envService
    }
  },
  methods: {
    showWiremockLogin() {
      return envService.isWiremockLogin() || window.location.host.indexOf('sms-dev') >= 0;
    },
    oidbLogin() {
      this.doLogin(envService.getOidbSsoId());
    },
    wiremockLogin() {
      this.doLogin(envService.getWiremockSsoId());
    },
    employeeLogin() {
      this.doLogin(envService.getSwisscomSsoId());
    },
    doLogin(ssoId) {
      if (envService.isDevMockEnv()) {
        this.$router.push('/login/' + ssoId);
      } else {
        window.location.href = envService.getLoginBaseUrl() + '/' + ssoId;
      }
    }
  },
};
</script>
<style scoped>
.container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.central-separator {
  border-right: 1px solid #d6d6d6;
}

.central-separator__text {
  color: #d6d6d6;
}

.central-separator__height {
  height: 100px;
}

</style>
